export const guestTypes = {
  adult: 'adult',
  youngAdult: 'youngAdult',
  child: 'child'
}



// WEBPACK FOOTER //
// ./src/constants/guestConstants.js